import { Suspense, lazy } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ProtectedRoute, useAuth } from '../../../../shared/ui';
import { UserRole } from '../../../../shared/utils/types';
import { NotFoundPage } from '../../pages/NotFoundPage';

const AdminUsersPage = lazy(() =>
  import('../../pages/admin/AdminUsersPage').then(m => ({
    default: m.AdminUsersPage,
  }))
);

const ProtectedAdminUsersPage = () => {
  const { user } = useAuth();
  if (user?.role !== UserRole.ADMIN) return <NotFoundPage />;
  return (
    <ProtectedRoute>
      <Suspense fallback={<div>Loading...</div>}>
        <AdminUsersPage />
      </Suspense>
    </ProtectedRoute>
  );
};

export const Route = createFileRoute('/admin/users')({
  component: ProtectedAdminUsersPage,
});
